import type { DataState } from '@/stores/dataStore';

/** The guild/DM a voice channel lives in (null when not in voice). */
export function voiceLocation(s: DataState, channelId: string | null) {
  if (!channelId) return null;
  for (const guildId of s.guildOrder) {
    const guild = s.guilds[guildId];
    const channel = guild?.channels.find((c) => c.id === channelId);
    if (channel) return { guildId, guildName: guild?.name ?? null, channelName: channel.name, isDm: false };
  }
  return { guildId: null, guildName: null, channelName: s.dmChannels[channelId]?.name ?? null, isDm: true };
}
